var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$.filter_button,
        _vm.delimiterLeft ? _vm.$.delimiter_left : "",
        _vm.delimiterRight ? _vm.$.delimiter_right : "",
        _vm.isActive ? _vm.$.with_refresh_button : "",
        "toolbar_filter_button",
      ],
    },
    [
      _vm.isActive
        ? _c("vgp-icon-button", {
            class: _vm.$.filter_refresh,
            attrs: {
              icon: { name: "update", size: 20 },
              colors: _vm.buttonColors,
              active: _vm.isActive,
            },
            on: { onClick: _vm.onClickRefreshFilter },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("vgp-icon-button", {
        class: [
          _vm.isOpen || _vm.isActive ? _vm.$.active : "",
          "header-filter-btn",
          "js_filter_btn",
        ],
        attrs: {
          icon: { name: "filter", size: 20 },
          label: _vm.locales("common_filter"),
          colors: _vm.buttonColors,
          active: _vm.isOpen || _vm.isActive,
        },
        on: { onClick: _vm.onClickFilter },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }